import { useCurrentUser } from '@billx/api';
import type { TooltipProps } from '@mui/material';
import { useTheme } from '@mui/material';
import { MoonIcon, SunMediumIcon } from 'lucide-react';

import { UtilityIconButton } from '@/components/common';

export const ThemeToggle = ({
  tooltip,
}: {
  tooltip?: Omit<TooltipProps, 'children' | 'title'>;
}) => {
  const { currentUser, updateUserPreference } = useCurrentUser();

  const theme = useTheme();
  const toggleTheme = async () => {
    if (currentUser) {
      const newTheme = theme.palette.mode === 'light' ? 'dark' : 'light';

      try {
        await updateUserPreference.mutateAsync({
          theme: newTheme,
        });
      } catch (error) {
        console.error('Error updating theme:', error);
      }
    }
  };

  return (
    <UtilityIconButton
      onClick={toggleTheme}
      sx={{
        transition: 'all 0.2s ease-in-out',
      }}
      tooltip={{
        title: 'Theme',
        ...tooltip,
      }}
    >
      {theme.palette.mode === 'light' ? (
        <MoonIcon size={20} />
      ) : (
        <SunMediumIcon size={20} />
      )}
    </UtilityIconButton>
  );
};
